import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import { Login, Register } from "@/pages/Auth";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import AIAssistant from "@/pages/dashboard/AIAssistant";
import Projects from "@/pages/dashboard/Projects";
import Portfolio from "@/pages/dashboard/Portfolio";
import RAAgent from "@/pages/dashboard/RAAgent";
import ResourcesPage from "@/pages/dashboard/ResourcesPage";
import FieldClaim from "@/pages/dashboard/fieldclaim/FieldClaim";
import ClaimDetail from "@/pages/dashboard/fieldclaim/ClaimDetail";
import LedgerPage from "@/pages/dashboard/fieldclaim/LedgerPage";
import DrfaPrograms from "@/pages/dashboard/DrfaPrograms";
import DrfaProgramDetail from "@/pages/dashboard/DrfaProgramDetail";
import TimeCapture from "@/pages/dashboard/TimeCapture";
import RecoveryMap from "@/pages/dashboard/RecoveryMap";
import LeadsInbox from "@/pages/dashboard/LeadsInbox";
import BusinessHub from "@/pages/dashboard/BusinessHub";
import AlphaHQ from "@/pages/dashboard/AlphaHQ";
import TaskBoard from "@/pages/dashboard/TaskBoard";
import Team from "@/pages/dashboard/Team";
import Contacts from "@/pages/dashboard/Contacts";
import Induction from "@/pages/dashboard/Induction";
import EWPrep from "@/pages/dashboard/EWPrep";
import RadarReview from "@/pages/dashboard/RadarReview";
import ContractAdmin from "@/pages/dashboard/ContractAdmin";
import ContractAdminDetail from "@/pages/dashboard/ContractAdminDetail";
import AssessorDemo from "@/pages/AssessorDemo";
import AIExpert from "@/pages/dashboard/AIExpert";
import DocumentLibrary from "@/pages/dashboard/DocumentLibrary";
import { FieldProvider } from "@/field/FieldContext";
import FieldApp from "@/field/FieldApp";
import FieldEvents from "@/field/pages/Events";
import FieldConnect from "@/field/pages/Connect";
import FieldEventDetail from "@/field/pages/EventDetail";
import FieldAssetForm from "@/field/pages/AssetForm";
import FieldAssetCapture from "@/field/pages/AssetCapture";
import FieldMap from "@/field/pages/FieldMap";
import FieldRunNav from "@/field/pages/RunNav";
import FieldSyncQueue from "@/field/pages/SyncQueue";
import FieldSwms from "@/field/pages/Swms";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/assess-demo/:shareId" element={<AssessorDemo />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="ai" element={<AIAssistant />} />
              <Route path="portfolio" element={<Portfolio />} />
              <Route path="raagent" element={<RAAgent />} />
              <Route path="fieldclaim" element={<FieldClaim />} />
              <Route path="fieldclaim/ledger" element={<LedgerPage />} />
              <Route path="fieldclaim/:claimId" element={<ClaimDetail />} />
              <Route path="drfa" element={<DrfaPrograms />} />
              <Route path="drfa/:programId" element={<DrfaProgramDetail />} />
              <Route path="timecapture" element={<TimeCapture />} />
              <Route path="map" element={<RecoveryMap />} />
              <Route path="leads" element={<LeadsInbox />} />
              <Route path="business" element={<BusinessHub />} />
              <Route path="alpha" element={<AlphaHQ />} />
              <Route path="tasks" element={<TaskBoard />} />
              <Route path="team" element={<Team />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="induction" element={<Induction />} />
              <Route path="ewprep" element={<EWPrep />} />
              <Route path="radar-review" element={<RadarReview />} />
              <Route path="contracts" element={<ContractAdmin />} />
              <Route path="contracts/:contractId" element={<ContractAdminDetail />} />
              <Route path="projects" element={<Projects />} />
              <Route path="resources" element={<ResourcesPage />} />
              <Route path="expert" element={<AIExpert />} />
              <Route path="library" element={<DocumentLibrary />} />
            </Route>
            <Route
              path="/field"
              element={
                <ProtectedRoute>
                  <FieldProvider>
                    <FieldApp />
                  </FieldProvider>
                </ProtectedRoute>
              }
            >
              <Route index element={<FieldEvents />} />
              <Route path="connect" element={<FieldConnect />} />
              <Route path="event/:claimId" element={<FieldEventDetail />} />
              <Route path="event/:claimId/asset/new" element={<FieldAssetForm />} />
              <Route path="asset/:assetId" element={<FieldAssetCapture />} />
              <Route path="asset/:assetId/edit" element={<FieldAssetForm />} />
              <Route path="map" element={<FieldMap />} />
              <Route path="run/:runId" element={<FieldRunNav />} />
              <Route path="sync" element={<FieldSyncQueue />} />
              <Route path="swms" element={<FieldSwms />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
